import type { Me } from '@/types';

/**
 * Dev-mode auth bypass. When VITE_DEV_MODE === 'true' the SPA skips MSAL
 * entirely: the App renders as if a fixed user is signed in, the API client
 * sends a plain X-Dev-User header instead of acquiring a token, and the
 * matching backend (DevModeAuthHandler) accepts it. Only used locally.
 */
export const devMode = import.meta.env.VITE_DEV_MODE === 'true';

export const devUser: Me & { objectId: string } = {
  objectId: '00000000-0000-0000-0000-000000000001',
  displayName: 'Daniel Morris (DEV)',
  upn: 'dev@keytravel.local',
  isAdmin: true,
  registrationStatus: 'Active',
  monthlyBudgetUsd: 50,
  spendThisMonthUsd: 12.34,
  alertThresholdPercent: null,
  budgetResetsAtUtc: '2026-08-01T00:00:00Z',
  // On in dev so compare mode is reachable locally without touching the database.
  compareModeEnabled: true,
  maxToolCallsLimit: 30
};
